import type { Severity } from "@/lib/intel/mock";

const MAP: Record<Severity, { label: string; cls: string }> = {
  low:      { label: "LOW",      cls: "text-success border-success/40 bg-success/10" },
  medium:   { label: "MEDIUM",   cls: "text-amber border-amber/40 bg-amber/10" },
  high:     { label: "HIGH",     cls: "text-[oklch(0.78_0.20_50)] border-[oklch(0.78_0.20_50)]/40 bg-[oklch(0.78_0.20_50)]/10" },
  critical: { label: "CRITICAL", cls: "text-danger border-danger/40 bg-danger/10" },
};
export function SeverityBadge({ s }: { s: Severity }) {
  const m = MAP[s];
  return (
    <span className={`inline-flex items-center gap-1 rounded-sm border px-1.5 py-0.5 font-mono text-[10px] tracking-widest ${m.cls}`}>
      <span className="h-1 w-1 rounded-full bg-current pulse-dot" />
      {m.label}
    </span>
  );
}
